import "core-js/modules/es.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    index: {
      type: Number,
      default: 0
    },
    isTopFix: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      arr: [0, 1, 2]
    };
  },
  computed: {
    lighUp: function lighUp() {
      return this.isTopFix ? 'float' : 'active';
    }
  },
  methods: {
    select: function select(k) {
      this.$emit('select', k);
    }
  }
};